import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const zendeskSlice = createSlice({
    name: 'zendesk',
    initialState: {
        unreadMessages: 0,
    },
    reducers: {
        setUnreadMessages: (state, action: PayloadAction<number>) => {
            state.unreadMessages = action.payload;
        },
    },
});

export const { setUnreadMessages } = zendeskSlice.actions;
export default zendeskSlice.reducer;